import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {HttpSecure} from '../../authentication/service/httpSecure.service';
import {AuthenticationService} from '../../authentication/service/authentication.service';

// import {CookieService} from "angular2-cookie/core";

@Injectable()

export class ApiService {

    constructor(private http: HttpSecure,
                private auth: AuthenticationService) {
        // //load cookie
        // this.getApiCookie();
        //
        // this._headers.set('Accept', 'application/json');
        // this._headers.set('Content-Type', 'application/json');
        // this._headers.set('privateToken', this._privateToken);
        //
        // this._options = new RequestOptions({
        //     headers: this._headers
        // })
    }

    // getApiCookie() {
    //     if (location.hostname == 'localhost') {
    //         console.log('DEV');
    //
    //         this._ip = 'dev';
    //         this._api = 'https://dev.marelease.ch:4242/';
    //         this._privateToken = 'aefc2474336650c593e19e9922ae5009ca8c90d42e';
    //
    //         this._isDev = true;
    //         return ;
    //     }
    //
    //     let cookie = this.cookieService.get('mareleaseV2');
    //
    //     if (!cookie) {
    //         this.logout();
    //         return ;
    //     }
    //
    //     let cook = cookie.split('.');
    //
    //     if (cook[0] == '0'){
    //         this._isDev = true;
    //     }
    //
    //
    //     this._ip = cook[1];
    //
    //     this._api = 'https://' + this._ip + '.marelease.ch:4242/';
    //     this._privateToken = cook[2];
    // }

    logout() {
        this.auth.logout()
    }

    logout2() {
        this.auth.logout()
    }

    // convertJsonToHttp(json: any): string {
    //     let http: string = "";
    //     for (let e in json) {
    //         http = http + "&" + e + "=" + json[e];
    //     }
    //     return http;
    // }

    get(path: string, data?: any) {
        let fullpath = path + '?' + data;
        if (!data) {
            fullpath = path;
        }
        return this.http.get(fullpath)
            .map((res: Response) => {
                return this.response(res);
            });
        // return this.http.get(this._api + path + "?" + data, this._options).map((res: Response) => {
        //     return this.response(res);
        // });
    }

    post(path: string, data: any) {
        return this.http.post(path, data)
            .map((res: Response) => {
                return this.response(res);
            });
        // return this.http.post(this._api + path, data, this._options).map((res: Response) => {
        //     return this.response(res);
        // });
    }

    postWithFile(path: string, formData, optionsCustom) {
        return this.http.post(path, formData, optionsCustom);
        // return this.http.post(this._api + path, formData, optionsCustom).map((res: Response) => {
        //     return this.response(res);
        // });
    }


    put(path: string, data: any) {
        return this.http.put(path, data)
            .map((res: Response) => {
                return this.response(res);
            });
        // return this.http.put(this._api + path, data, this._options).map((res: Response) => {
        //     return this.response(res);
        // });
    }

    delete(path: string, data: any) {
        return this.http.delete(path, data)
            .map((res: Response) => {
                return this.response(res);
            });
    }

    error(err) {
        console.error(err);
        if (err.status == 404) {
            this.logout();
            return null;
        }
    }

    response(res: Response) {
        return res.json();
    }

    downloadWithTempToken(url, noParam = false) {
        this.http
            .get('/auth/temptoken')
            .subscribe((res: Response) => {
                let token = res.json().token;
                if (noParam) {
                    window.open(this.http.baseUrl + url + '?tempToken=' + token, '_blank');
                } else {
                    window.open(this.http.baseUrl + url + '&tempToken=' + token, '_blank');
                }
            })
    }

    downloadFile(id: string) {
        this.downloadWithTempToken('file?privateId=' + id)
        // window.open(this._api + "file?privateToken=" + this._privateToken + "&privateId=" + id, "_blank");
    }

    downloadLetter(idPdf: string) {
        this.downloadWithTempToken('letterPdf?idPdf=' + idPdf)
        // window.open(this._api + "letterPdf?privateToken=" + this._privateToken + "&idPdf=" + idPdf, "_blank");
    }

    invoiceHtml(id: string) {
        this.downloadWithTempToken('billHtml?privateId=' + id)
        // window.open(this._api + "billHtml?privateToken=" + this._privateToken + "&privateId=" + id, "_blank");
    }

    quoteHtml(id: string) {
        this.downloadWithTempToken('quoteHtml?privateId=' + id)
        // window.open(this._api + "billHtml?privateToken=" + this._privateToken + "&privateId=" + id, "_blank");
    }

    serviceHtml(clientPrivateId: string, servicePrivateId) {
        this.downloadWithTempToken('clientFite?privateId=' + clientPrivateId + '&servicePrivateId=' + servicePrivateId)
        // window.open(this._api + "clientFite?privateToken=" + this._privateToken + "&privateId=" + clientPrivateId + "&servicePrivateId=" + servicePrivateId, "_blank");
    }

    upload(privateId, file) {
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return this.http.postFile('file', formData, privateId)
    }

    invoicePdf(id: string) {
        this.downloadWithTempToken('billPdf?privateId=' + id)
        // window.open(this._api + 'billPdf?privateToken=' + this._privateToken + '&privateId=' + id, '_blank');
    }

    quotePdf(id: string) {
        this.downloadWithTempToken('quotePdf?privateId=' + id)
        // window.open(this._api + 'billPdf?privateToken=' + this._privateToken + '&privateId=' + id, '_blank');
    }

    servicePdf(id: string) {
        // window.open(this._api + 'service/pdf?privateToken=' + this._privateToken + '&privateId=' + id, '_blank');
        this.downloadWithTempToken('service/pdf?privateId=' + id);
    }

    orderPdf(id: string) {
        this.downloadWithTempToken('order/' + id + '/pdf?id=' + id);
        // window.open(this._api + 'order/' + id + '/pdf?privateToken=' + this._privateToken + '&id=' + id, '_blank');
    }

    campagneCSV(id: string) {
        this.downloadWithTempToken('campagne/' + id + '/csv?id=' + id);
        // window.open(this._api + 'campagne/' + id + '/csv?privateToken=' + this._privateToken + '&id=' + id, '_blank');
    }

    // get ip(): string {
    //     return this._ip;
    // }
    //
    // get api(): string {
    //     return this._api;
    // }
    //
    // set api(value: string) {
    //     this._api = value;
    // }
    //
    // get privateToken(): string {
    //     return this._privateToken;
    // }
    //
    // set privateToken(value: string) {
    //     this._privateToken = value;
    // }
    //
    // get headers(): Headers {
    //     return this._headers;
    // }
    //
    // set headers(value: Headers) {
    //     this._headers = value;
    // }
    //
    // get options(): RequestOptions {
    //     return this._options;
    // }
    //
    // set options(value: RequestOptions) {
    //     this._options = value;
    // }
    //
    // get isDev(): boolean {
    //     return this._isDev;
    // }
    //
    // set isDev(value: boolean) {
    //     this._isDev = value;
    // }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/api.service.ts